import React, { useRef } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import AddNoteForm from '../Notes/AddNoteForm';
import NoteList, { INoteListForwardRef } from '../Notes/NoteList';
import { NotesHistory } from './NotesHistory';

const NotesTab: React.FC<{}> = () => {
  const noteListRef = useRef<INoteListForwardRef>(null);

  return (
    <>
      <Flex gap={4} flexDirection="column">
        <Flex
          flexDirection="column"
          alignItems="flex-start"
          gap={2}
          marginBottom={4}
        >
          <Text textStyle="headingSection">Notes</Text>
        </Flex>
        {/* Add notes */}
        <Flex justifyContent="start" gap={4} flexDirection="column">
          <AddNoteForm
            onAddNote={() => {
              noteListRef.current?.refetchNotes?.();
            }}
          />
        </Flex>
      </Flex>

      {/* Note list */}
      <NoteList ref={noteListRef} />

      {/* Notes from previously linked journals */}
      <NotesHistory />
    </>
  );
};

export default NotesTab;
